<!--
 * @Descripttion: 
 * @Author: Gavin
 * @version: 
 * @Date: 2020-07-28 16:00:51
 * @LastEditTime: 2020-08-17 17:52:36
--> 
<template>
  <section class="knowledge-search-wrapper">
    <!-- 分类 -->
    <md-tab-bar v-model="tabActive" :items="listDataAll" :maxLength="4" :has-ink="false" @change="handleChangeTab">
      <template slot="item" slot-scope="{ item }">
        <span>{{item.label}}({{item.list.length}})</span>
      </template>
    </md-tab-bar>

    <md-scroll-view
      :scrolling-x="false"
      :auto-reflow="true"
      class="knowledge-search-scroll-view-wrapper"
      ref="knowledgeScrollView"
      @end-reached="onEndReached"
      :end-reached-threshold="200"
      :immediate-check-end-reaching="false"
      v-loading="isLoading">
      <ListItem
        :list="listData"
        :colClass="tabActive==='faction'||tabActive==='carton'?'col-3':'col-2'"
      />
    </md-scroll-view>
  </section>
</template>

<script>
import ListItem from "@/pages/home/components/listItem";
import { getSource, getYouZanKeGoods } from "@/api/distribution";
export default {
  data() {
    return {
      listData: [],
      listDataAll: [],
      isLoading: false,
      searchParams: {
        filter: "",
        tag: "", //tag & filter 只能其一
        type: "",
        order: "", //asc desc
        orderBy: "", //佣金: commission_money, 佣金比例: media_distribution_proportion, 已购人数: sell_count, 上架时间: work_time
        isNeedPage: 0,
        platformCode: "",
        hasDocumentUrl: "",
        pageNum: 0,
        pageSize: 100,
      },
      tabActive: ''
    }
  },
  props: {
    searchText: {
      type: String,
      default: ''
    }
  },
  components: {
    ListItem
  },
  methods: {
    //获取知识分销搜索结果
    load() {
      this.isLoading = true;

      let text = this.searchText,
        _tag = "",
        _filter = "";
      if (/^tag:/.test(text)) {
        _tag = text.match(/^tag:(.*)/)[1] || "";
      } else {
        _filter = text;
      }
      this.searchParams.tag = _tag;
      this.searchParams.filter = _filter;
      
      getSource(this.searchParams).then((res) => {
        this.isLoading = false;
        this.listDataAll = [];

        let _data = res.data || [];
        let _course = [],
          _ceping = [],
          _faction = [],
          _carton = [];
        _data.forEach((item) => {
          if (this.returnType(item.type) === "course") {
            _course.push(item);
          }
          if (this.returnType(item.type) === "ceping") {
            _ceping.push(item);
          }
          if (this.returnType(item.type) === "faction") {
            _faction.push(item);
          }
          if (this.returnType(item.type) === "carton") {
            _carton.push(item);
          }
        });

        if (_course.length) {
          this.listDataAll.push({
            label: "付费课程",
            name: "course",
            list: _course,
          });
        }
        if (_ceping.length) {
          this.listDataAll.push({
            label: "测评测算",
            name: "ceping",
            list: _ceping,
          });
        }
        if (_faction.length) {
          this.listDataAll.push({
            label: "热卖小说",
            name: "faction",
            list: _faction,
          });
        }
        if (_carton.length) {
          this.listDataAll.push({
            label: "精选漫画",
            name: "carton",
            list: _carton,
          });
        }

        if(this.listDataAll.length) {
          this.tabActive = this.listDataAll[0].name;
          this.listData = this.listDataAll[0].list;
        }
      });
    },
    onEndReached() {

    },
    //判断知识分销类型
    returnType(type = "") {
      let typeAry = type.split(","),
        result = null;

      switch (typeAry[0]) {
        case "1":
          result = "course";
          break;
        case "24":
          result = "ceping";
          break;
        case "2":
          result = "faction";
          break;
        case "3":
          result = "carton";
          break;
      }
      return result;
    },
    // change tab
    handleChangeTab(tab) {
      if(this.tabActive === tab.name) return;

      this.tabActive = tab.name;
      this.listDataAll.forEach((item) => {
        if (item.name === tab.name) {
          this.listData = item.list;
        }
      });
    },
  },
  created() {
    this.load()
  }
}
</script>

<style lang="scss">
.knowledge-search-wrapper{

  .md-tab-bar{
    padding: 0 26px;
    height: 80px;
    background-color: #fff;
  }
  .md-tab-bar-start, .md-tab-bar-end{
    height: 80px;
  }
  .md-tab-bar-item{
    padding: 0;
    padding-right: 64px;
    min-height: 80px;

    &:last-child{
      padding-right: 0;
    }
  }
}
.knowledge-search-scroll-view-wrapper{
  height: calc(100vh - 124px - 80px);
}
</style>